if (!customElements.get("am-klaviyo")) {
  customElements.define(
    "am-klaviyo",
    class AmKlaviyo extends HTMLElement {
      constructor() {
        super();
      }
      handleSubmit(e) {
        this.inputEmail = $('am-klaviyo form input[type="email"]').val().trim();
        if (this.checkbox && !this.isChecked()) {
          e.preventDefault();
          //   this.querySelector(".am-klaviyo-error-msg").classList.add("active");
          if (this.button) {
            this.buttonWrapper.classList.remove("unlocked");
          }
        } else {
          //   this.querySelector(".am-klaviyo-error-msg").classList.remove(
          //     "active",
          //   );
          this.buttonWrapper.classList.add("unlocked");
        }
      }
      handleCheck() {
        if (this.isChecked()) {
          if (this.buttonWrapper) {
            this.buttonWrapper.classList.add("unlocked");
            // this.querySelector(".am-klaviyo-error-msg").classList.remove(
            //   "active",
            // );
          }
        } else {
          if (this.buttonWrapper) {
            this.buttonWrapper.classList.remove("unlocked");
            // this.querySelector(".am-klaviyo-error-msg").classList.add("active");
          }
        }
      }
      isChecked() {
        return this.checkbox.checked;
      }
      connectedCallback() {
        this.inputEmail = "";
        this.klaviyoWrapper = this.querySelector('[class^="klaviyo-form-"]');
        // Klaviyo表单检测
        console.log("初始化..........", this.klaviyoWrapper);
        const errorMessageEl = document.createElement("div");
        errorMessageEl.innerHTML = `<div class="am-klaviyo-error-msg">
              プライバシーポリシーを確認し、下のチェックボックスにチェックしてください。
            </div>`;
        const observer_0 = new MutationObserver((mutations) => {
          console.log(
            "有变化",
            this.querySelector('form[data-testid^="klaviyo-form-"]'),
          );
          const klForm = this.querySelector(
            'form[data-testid^="klaviyo-form-"]',
          );
          if (
            klForm &&
            klForm.querySelector(
              '[data-testid="form-row"]:nth-child(2) fieldset label',
            )
          ) {
            // 检测初始化成功
            observer_0.disconnect();
            console.log(
              "初始化成功",
              klForm.querySelector('[data-testid="form-row"]'),
              document.querySelector(".strava-klaviyo-terms-hidden"),
            );
            // klForm
            //   .querySelector('[data-testid="form-row"]:nth-child(1) > div')
            //   .append(errorMessageEl.firstChild);
            this.checkbox = document.querySelector(
              '[data-testid="form-row"]:nth-child(2) fieldset input',
            );
            this.button = this.querySelector(".klaviyo-form button");
            // this.button.innerText = "S'abonner";
            this.buttonWrapper = this.button.closest("div");
            if (this.checkbox) {
              this.checkbox.addEventListener(
                "change",
                this.handleCheck.bind(this),
              );
            }
            if (this.buttonWrapper) {
              this.buttonWrapper.classList.remove("unlocked");
              this.buttonWrapper.addEventListener(
                "click",
                this.handleSubmit.bind(this),
              );
            }

            const radioLabels = klForm.querySelectorAll(
              '[data-testid="form-row"]:nth-child(1) fieldset label',
            );
            radioLabels.forEach((radioLabel) => {
              const newSvg = document.createElement("div");
              newSvg.innerHTML = `<svg style="display: none;position: absolute;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="12" fill="#FF7A3D"/>
                <path d="M18.7031 5.89458C19.0041 5.89458 19.1811 6.24186 18.9902 6.48247L18.9912 6.48344L10.4053 17.3624V17.3633C10.0888 17.7608 9.4834 17.7616 9.16797 17.3624L4.35352 11.2627C4.16517 11.0236 4.33541 10.6721 4.64062 10.6719H5.87012C5.98888 10.6721 6.10606 10.6992 6.21289 10.751C6.31972 10.8029 6.41375 10.8785 6.4873 10.9717L9.78613 15.1504L16.8564 6.19438C17.0051 6.00419 17.2342 5.8946 17.4746 5.89458H18.7031Z" fill="white" stroke="white" stroke-width="0.45"/>
              </svg>`;
              const svgs = radioLabel.querySelectorAll("svg");
              console.log("2 svg", svgs);
              console.log("newSvg - 2", newSvg.firstChild);
              if (svgs.length >= 2 && newSvg.firstChild) {
                radioLabel.replaceChild(newSvg.firstChild, svgs[1]);
                //  radioLabel.removeChild(svgs[1]);
                //   radioLabel.append(newSvg.firstChild);
              }
            });

            klForm.querySelector(
              '[data-testid="form-row"]:nth-child(2) fieldset label>div',
            ).innerHTML = document.querySelector(
              ".strava-klaviyo-terms-hidden",
            ).innerHTML;
          }
        });
        const observer = new MutationObserver((mutations) => {
          console.log(
            "有变化 22",
            this.querySelector('form[data-testid^="klaviyo-form-"]'),
          );
          const klForm = this.querySelector(
            'form[data-testid^="klaviyo-form-"]',
          );
          console.log("klForm.innerText", klForm, klForm.textContent);
          if (klForm) {
            // 检测提交成功
            if (
              klForm.textContent.indexOf("Merci pour votre abonnement !") > -1
            ) {
              observer.disconnect();
              console.log("提交成功");
              this.classList.add("submitted");
              this.closest(".shopify-section")
                .querySelectorAll(".klaviyo-origin-text")
                .forEach((el) => {
                  el.classList.remove("active");
                });
              this.closest(".shopify-section")
                .querySelectorAll(".klaviyo-success-text")
                .forEach((el) => {
                  el.classList.add("active");
                });
              this.querySelector("simple-dialog-trigger").dispatchEvent(new CustomEvent("force-open"));
              const inputEmail = this.inputEmail;
              //    this.querySelector('discount-code').setAttribute(
              //       'code',
              //       document.querySelector('[aria-label="Copy coupon code"]').innerText
              //     );
              //     this.querySelector('.strava-klaviyo-copy').style.display = 'block';
              //     this.closest('.strava-utmb-banner-2025').querySelector('.subscribe-title').style.display =
              //       'none';
            }
          }
        });
        if (this.querySelector('form[data-testid^="klaviyo-form-"]')) {
          const klForm = this.querySelector(
            'form[data-testid^="klaviyo-form-"]',
          );
          observer_0.disconnect();
          console.log(
            "初始化成功",
            klForm.querySelector("fieldset label>div"),
            document.querySelector(".strava-klaviyo-terms-hidden"),
          );
          klForm.querySelector("fieldset label>div").innerHTML =
            document.querySelector(".strava-klaviyo-terms-hidden").innerHTML;
        }

        // 开始观察DOM变化
        observer_0.observe(this.klaviyoWrapper, {
          childList: true,
          subtree: true,
        });
        observer.observe(this.klaviyoWrapper, {
          childList: true,
          subtree: true,
        });
      }
    },
  );
}

// 定义 SimpleDialogTrigger 自定义元素
class SimpleDialogTrigger extends HTMLElement {
  constructor() {
    super();
    console.log(
      "simple dialog trigger 构造",
      this.querySelector("simple-dialog"),
    );
  }

  connectedCallback() {
    // 获取对话框ID
    const dialogId = this.getAttribute("data-dialog-trigger");
    // 查找对话框元素
    let dialog = this.querySelector("simple-dialog");
    this.dialog = dialog;
    if (dialog) {
      dialog.setAttribute("id", dialogId);
    }

    // 如果还没有对话框内容，则创建
    if (!dialog) {
      dialog = document.querySelector(`#${dialogId}`);
      //  const mask = dialog.querySelector(".simple-dialog-mask")
      // // 点击遮罩层关闭对话框
      // mask.addEventListener('click', () => {
      //   this.closeDialog(dialog);
      // });
      // 添加点击事件监听
      this.addEventListener("click", () => {
        this.openDialog(dialog);
      });
      
      this.dialog = dialog;
    } else if (dialog) {
      // 确保对话框结构完整
      this.ensureDialogStructure(dialog);

      // 将对话框移动到body末尾（如果尚未移动）
      if (!dialog.movedToBody) {
        document.body.appendChild(dialog);
        dialog.movedToBody = true;
      }

      // 添加点击事件监听
      this.addEventListener("click", () => {
        this.openDialog(dialog);
      });
    }
    this.addEventListener("force-open", () => {
        this.openDialog(dialog);
      });
  }

  // 确保对话框包含必要的结构元素
  ensureDialogStructure(dialog) {
    // 如果还没有遮罩层，则创建
    if (!dialog.querySelector(".simple-dialog-mask")) {
      const mask = document.createElement("div");
      const closeBtn = dialog.querySelector(".simple-dialog-close");
      mask.className = "simple-dialog-mask";
      dialog.insertBefore(mask, dialog.firstChild);

      // 点击遮罩层关闭对话框
      mask.addEventListener("click", () => {
        this.closeDialog(dialog);
      });
    }

    // 如果还没有关闭按钮，则创建
    if (!dialog.querySelector(".simple-dialog-close")) {
      const closeBtn = document.createElement("button");
      closeBtn.className = "simple-dialog-close";
      closeBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 13.4142L0 1.41421L1.41421 0L13.4142 12L12 13.4142Z" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M-0.000150251 12L11.9998 -6.18172e-08L13.4141 1.41421L1.41406 13.4142L-0.000150251 12Z" fill="black"/>
      </svg>
      `;
      closeBtn.setAttribute("aria-label", "关闭对话框");

      // 将关闭按钮添加到内容区域
      const content = dialog.querySelector(".simple-dialog-content");
      if (content) {
        content.appendChild(closeBtn);
      } else {
        // 如果没有内容区域，则直接添加到对话框
        dialog.appendChild(closeBtn);
      }

      // 点击关闭按钮关闭对话框
      closeBtn.addEventListener("click", () => {
        this.closeDialog(dialog);
      });
    }
  }

  // 打开对话框
  openDialog(dialog) {
    dialog.classList.add("simple-dialog-open");
    document.body.style.overflow = "hidden"; // 防止背景滚动

    // 添加ESC键关闭功能
    const escHandler = (e) => {
      if (e.key === "Escape") {
        this.closeDialog(dialog);
        document.removeEventListener("keydown", escHandler);
      }
    };

    document.addEventListener("keydown", escHandler);
    dialog._escHandler = escHandler;

    // 将焦点设置到关闭按钮
    const closeBtn = dialog.querySelector(".simple-dialog-close");
    if (closeBtn) {
      // setTimeout(() => closeBtn.focus(), 100);
    }
  }

  // 关闭对话框
  closeDialog(dialog) {
    dialog.classList.remove("simple-dialog-open");
    document.body.style.overflow = ""; // 恢复背景滚动

    // 移除ESC键监听
    if (dialog._escHandler) {
      document.removeEventListener("keydown", dialog._escHandler);
      delete dialog._escHandler;
    }

    // 将焦点返回到触发按钮
    this.focus();
  }
}

// 注册自定义元素
if (!customElements.get("simple-dialog-trigger")) {
  customElements.define("simple-dialog-trigger", SimpleDialogTrigger);
}
